import React, { useState, useEffect } from "react";

import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import Plancontent from "../../components/plan/plan_content";
import Spinner from "../../components/Spinner/spinner";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
const Plan = () => {
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    const token_horoscope = localStorage.getItem(
      `${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`,
    );
    if (!token && !token_horoscope) {
      navigate("/signin", { replace: true });
    }
  }, []);

  useEffect(() => {
    const start = Date.now();
  }, []);
  return <>{showSpinner ? <Spinner /> : <Plancontent />}</>;
};

export default Plan;
